import { render, staticRenderFns } from "./LocalSettings.vue?vue&type=template&id=f6b63e1e&"
import script from "./LocalSettings.vue?vue&type=script&lang=js&"
export * from "./LocalSettings.vue?vue&type=script&lang=js&"
import style0 from "./LocalSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports